var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-text", class: { rtl: this.$store.state.rtl } },
    [
      _c("div", {
        staticClass: "section-text__content",
        domProps: { innerHTML: _vm._s(_vm.seoText) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }